export default "/static/webpack/media/menu.b20a1541.svg";